import get from 'lodash/get';

const getApplicationConfig = () => get(window, 'bugherd.config');

export const isExtensionSupported = () => {
  const config = getApplicationConfig();
  return config ? get(config, 'extension.supportedBrowser') : null;
};
